import { atom } from 'recoil'

export const isOpenSettingsDetailsState = atom({
  key: 'isOpenSettingsDetailsState',
  default: false
})
